/*
 * @Author: zhao - 🍉
 * @Date: 2022-01-29 18:06:41
 * @LastEditTime: 2022-01-29 18:46:58
 * @LastEditors: zhao - 🍉
 * @Description: 平台对账 - 惠市宝对账单汇总列表->汇总数据订单明细数据->详情
 * @FilePath: /zhzj-admin/src/page/PlatformAccountingRecord/HSBList/components/HSBInfoDetail.jsx
 */


import { Button, Modal } from 'antd';
import React, { useState } from 'react'
import { mapOrdrTpcd, mapRcnclRsltStcd } from '../../../../axios/dictionaries';
import { CustomCol, CustomRow } from '../../../../components/Custom';
import DetailTitle from '../../../../components/DetailTitle';
import ModalScrollContainer from '../../../../components/ModalScrollContainer';
import { fetchPlatformRecordHsbPayOrderSummaryDataOrderGet } from '../../../../services/platformAccountingRecord';
import { findDict, formatTime } from '../../../../utils';

const HSBInfoDetail = (props) => {
    const [visible, setVisible] = useState(false);
    const [loading, setLoading] = useState(false);
    const [detailData, setDetailData] = useState({});
    const open = (id) => {
        setVisible(true)
        postGet(id)
    }
    const close = () => {
        setVisible(false)
    }
    const postGet = (id) => {
        setLoading(true)
        fetchPlatformRecordHsbPayOrderSummaryDataOrderGet({id}).then(res => {
            setDetailData(res)
        }).finally(() => {
            setLoading(false)
        })
    }
    props.getRef && props.getRef({ open });
    return (
        <Modal 
            title="对账详情" 
            width={950} 
            visible={visible} 
            onCancel={close} 
            footer={<Button onClick={close}>关闭</Button>}
        >
             <ModalScrollContainer style={{ paddingTop: 0 }} loading={loading}>
                <div className="custom" >
                    <DetailTitle title="基础信息" />
                    <CustomRow >
                        <CustomCol label="交易金额">
                            <span style={{ paddingLeft:6 }}>{detailData.txnamt}</span>
                        </CustomCol>
                        <CustomCol label="手续费">
                            <span style={{ paddingLeft:6 }}>{detailData.hdCg}</span>
                        </CustomCol>
                        <CustomCol label="交易日期">
                            <span style={{ paddingLeft:6 }}>{formatTime(detailData.txnDt)}</span>
                        </CustomCol>


                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="订单类型代码">
                            <span style={{ paddingLeft:6 }}>{ findDict(mapOrdrTpcd, detailData.ordrTpcd).title }</span>
                        </CustomCol>
                        <CustomCol label="支付流水号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.ordrNo}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="渠道">
                            <span style={{ paddingLeft:6 }}>{detailData.lssubnkDsc}</span>
                        </CustomCol>
                    
                        <CustomCol label="主订单编号" colStyle={{ width: 500 }}>
                            <span style={{ paddingLeft:6 }}>{detailData.mainOrdrNo}</span>
                        </CustomCol>
                    
                    </CustomRow>
                    <CustomRow divider>

                        <CustomCol label="借记卡等">
                            <span style={{ paddingLeft:6 }}>{detailData.pyCrdtpDsc}</span>
                        </CustomCol>
                    
                        <CustomCol label="卡号">
                            <span style={{ paddingLeft:6 }}>{detailData.pyrAccno}</span>
                        </CustomCol>
                    </CustomRow>
                    <CustomRow divider>
                        <CustomCol label="收款状态代码">
                            <span style={{ paddingLeft:6 }}>{findDict(mapRcnclRsltStcd, detailData.rcnclRsltStcd).title}</span>
                        </CustomCol>

                        <CustomCol label="交易时间">
                            <span style={{ paddingLeft:6 }}>{detailData.txnTm}</span>
                        </CustomCol>
                    </CustomRow>
                </div>
            </ModalScrollContainer>
        </Modal>
    )
}

export default HSBInfoDetail



// WEBPACK FOOTER //
// ./src/page/PlatformAccountingRecord/HSBList/components/HSBInfoDetail.jsx